var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":"danger","icon":"el-icon-delete","size":"mini"},on:{"click":function($event){return _vm.removeRoleById(_vm.roleId)}}},[_vm._v("删除")])
}
var staticRenderFns = []

export { render, staticRenderFns }